import { useMemo } from 'react';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { TaskStatus } from '../../types';

export interface FilterState {
  // List view filters
  listStatusFilter: TaskStatus[];
  setListStatusFilter: (filter: TaskStatus[]) => void;
  listHorizonFilter: string[];
  setListHorizonFilter: (filter: string[]) => void;
  listTagsFilter: string[];
  setListTagsFilter: (filter: string[]) => void;
  listTaskTypeFilter: 'all' | 'parent_only' | 'child_only';
  setListTaskTypeFilter: (filter: 'all' | 'parent_only' | 'child_only') => void;

  // Memoized filter state
  currentFilters: {
    statusFilter: TaskStatus[];
    horizonFilter: string[];
    tagsFilter: string[];
    taskTypeFilter: 'all' | 'parent_only' | 'child_only';
    setStatusFilter: (filter: TaskStatus[]) => void;
    setHorizonFilter: (filter: string[]) => void;
    setTagsFilter: (filter: string[]) => void;
    setTaskTypeFilter: (filter: 'all' | 'parent_only' | 'child_only') => void;
  };
}

export function useFilterState(): FilterState {
  const [listStatusFilter, setListStatusFilter] = useLocalStorage<TaskStatus[]>('todoApp_listStatusFilter', []);
  const [listHorizonFilter, setListHorizonFilter] = useLocalStorage<string[]>('todoApp_listHorizonFilter', []);
  const [listTagsFilter, setListTagsFilter] = useLocalStorage<string[]>('todoApp_listTagsFilter', []);
  const [listTaskTypeFilter, setListTaskTypeFilter] = useLocalStorage<'all' | 'parent_only' | 'child_only'>('todoApp_listTaskTypeFilter', 'all');

  const currentFilters = useMemo(() => ({
    statusFilter: listStatusFilter,
    horizonFilter: listHorizonFilter,
    tagsFilter: listTagsFilter,
    taskTypeFilter: listTaskTypeFilter,
    setStatusFilter: setListStatusFilter,
    setHorizonFilter: setListHorizonFilter,
    setTagsFilter: setListTagsFilter,
    setTaskTypeFilter: setListTaskTypeFilter
  }), [
    listStatusFilter,
    listHorizonFilter,
    listTagsFilter,
    listTaskTypeFilter,
    setListStatusFilter,
    setListHorizonFilter,
    setListTagsFilter,
    setListTaskTypeFilter
  ]);

  return {
    listStatusFilter,
    setListStatusFilter,
    listHorizonFilter,
    setListHorizonFilter,
    listTagsFilter,
    setListTagsFilter,
    listTaskTypeFilter,
    setListTaskTypeFilter,
    currentFilters
  };
}
